import React from "react";
import "./CreateNewPin.scss";
import {MDBBox, MDBIcon, MDBTypography} from "mdbreact";
import cogoToast from "cogo-toast";
import CreatePinMutation from "../../mutations/CreatePinMutation";
import {setForgetPin, setLoginStep, userLogin} from "../../Actions";
import {connect} from "react-redux";
import LoginHeader from "../../component/LoginHeader/LoginHeader";
import {Slide} from "react-reveal";
import ForgetPinMutation from "../../mutations/ForgetPinMutation";
import {withRouter} from "react-router-dom";
import {assetUrl} from "../../serviceApi";
const Phone = assetUrl+"images/login-mobile.png";
const Lock = assetUrl+"images/lock.svg";
const RedDots = assetUrl+"images/red-dots-large.png";
const NetaLogo = assetUrl+"images/neta-logo-sm.png";
const eye = assetUrl+"images/eye_open.svg";
const eyelash = assetUrl+"images/eyeClose.svg";


class CreateNewPin extends React.Component {
	state = {
		// email:"",
		pin: "",
		loading: false,
		trigger: false,
		confirm_pin:"",
		show_password1:false,
		show_password2:false
	}

	componentDidMount() {
		this.setState({...this.state, trigger: true})
	}

	handleInputChange = (e, feild) => {
		let value;
		if (feild === "pin" || feild === "confirm_pin") {
			value = (e.target.validity.valid) ? e.target.value : this.state.pin;
		} else {
			value = e.target.value;
		}
		this.setState({
			[feild]: value
		})
	}

	togglePassword = () => {
		this.setState({
			show_password1:!this.state.show_password1
		})
	}
	togglePasswordConfirm = () => {
		this.setState({
			show_password2:!this.state.show_password2
		})
	}
	rippleEffect = (e) => {
		if (this.state.validated === false) {
			let x = e.clientX;
			let y = e.clientY;
			let buttonTop = e.target.offsetTop;
			let buttonLeft = e.target.offsetLeft;
			let xInside = x - buttonLeft;
			let yInside = y - buttonTop;

			let circle = document.createElement('span');
			circle.classList.add('create-pin-circle');
			// circle.style.top = yInside + 'px';
			circle.style.left = xInside + 'px';
			if (document.querySelector(".submit-btn")) {

				document.querySelector(".submit-btn").appendChild(circle);

				setTimeout(() => {

					circle.remove();

				}, 100);

			}
		}
	}

	handleSubmit = (e) => {
// debugger
		// this.rippleEffect(e)
		let data = {
			// email:this.state.email,
			mobileNumber: "+91"+this.props.user_details.mobileNumber,
			pin: this.state.pin,
			username:this.props.user_details.username,
			referralCode:localStorage.getItem("refCode")
		}
		let Updatedata = {
			// email:this.state.email,
			mobileNumber: "+91"+this.props.user_details.mobileNumber,
			pin: this.state.pin,
			username:this.props.user_details.username,
		}
		let scope = this;
		// if(this.state.email === "" || EmailValidator.validate(this.state.email) === false ){
		//     cogoToast.warn("please fill valid email", { position: 'top-center'});
		// } else
		if (scope.state.pin === "") {
			cogoToast.warn("please fill valid pin", {position: 'top-center'});
		} else if (scope.state.pin.length < 4) {
			cogoToast.warn("pin number should be 4 digits", {position: 'top-center'});
		} else if (scope.state.confirm_pin === "") {
			cogoToast.warn("please fill valid pin", {position: 'top-center'});
		} else if (scope.state.confirm_pin.length < 4) {
			cogoToast.warn("confirm pin number should be 4 digits", {position: 'top-center'});
		} else if(scope.state.pin !== scope.state.confirm_pin){
			cogoToast.warn("Pin numbers did not match", {position: 'top-center'});
		} else {
			scope.setState({
				loading: true
			})
			if(this.props.forgetPinIs) {
				ForgetPinMutation(Updatedata, function (response) {
					debugger
					// debugger
					scope.setState({
						loading: false
					})

					if (!response.forgotPin.error) {
						cogoToast.success(response.forgotPin.message, {position: 'top-center'});
						scope.setUserData(response.forgotPin);
					} else {
						cogoToast.error(response.forgotPin.message, {position: 'top-center'});
					}
					scope.props.setForgetPin(false);
				}, function (err) {
					scope.setState({
						loading: false
					})
					cogoToast.error(err, {position: 'top-center'});
				})
			}else {
				CreatePinMutation(data, function (response) {
					// debugger
					scope.setState({
						loading: false
					})
					if (response.createPin.error === false) {
						// cogoToast.success(response.createPin.message, {position: 'top-center'});
						scope.setUserData(response.createPin);
					} else {
						cogoToast.error(response.createPin.message, {position: 'top-center'});
					}
				}, function (err) {
					scope.setState({
						loading: false
					})
					cogoToast.error(err, {position: 'top-center'});
				});
			}
		}
	}

	setUserData = (res) => {
		debugger
		let data
		if(this.props.forgetPinIs){
			data = {
				user_details: {
					username:this.props.user_details.username,
					mobileNumber: this.props.user_details.mobileNumber,
					token: res.token,
					// token: "",
					welcomeBonus:"",
					refreshToken: res.refreshToken,
					// refreshToken: "",
					user: res.user
				},
				logged_in: true,

			}

		}else{
			data = {
				user_details: {
					username:this.props.user_details.username,
					mobileNumber: this.props.user_details.mobileNumber,
					token: res.token,
					// token: "",
					welcomeBonus:res.wallet.availableGrantMoney,
					refreshToken: res.refreshToken,
					// refreshToken: "",
					user: res.user
				},
				logged_in: true,
			}
			// localStorage.removeItem("token");
			// localStorage.removeItem("refreshToken");
		}
		localStorage.setItem("token",res.token)
		localStorage.setItem("refreshToken",res.refreshToken)
		this.props.addUserData(data);
		this.setState({...this.state, trigger: false})
		// setTimeout(() => {

			if(this.props.forgetPinIs){
				// debugger
				// this.props.setLoginStep(5);
				// this.props.handleLoginSteps(5);
				this.props.setLoginStep(0);
				this.props.handleLoginSteps(0);
				// this.props.completeLogin();
				// this.props.history.push("/home");

			}else{
				this.props.setLoginStep(4);
				this.props.handleLoginSteps(4);
			}

		// },1000)

	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.trigger !== this.state.trigger) {
			document.querySelector("#submitButton-new").addEventListener("click", () => {
				this.handleSubmit()
				// if(this.state.validated === true){

				// }

			})
		}
	}
	goToPreviousPage = () => {
		if(this.props.forgetPinIs){
			this.props.handleLoginSteps(1);
			this.props.setLoginStep(1);
		}else{
			this.props.handleLoginSteps(2);
			this.props.setLoginStep(2);
		}

	}

	onCancelButton=()=>{
		if(this.props.forgetPinIs){
			this.props.history.goBack()
		}else{
			this.props.handleLoginSteps(0);
			this.props.setLoginStep(0);
		}
	}
	render() {
		return (
			<MDBBox
				className="create-password-form-component d-flex flex-column justify-content-between px-3 pt-4 pb-3">
				<MDBBox >
					<LoginHeader
						handleBackClick={this.goToPreviousPage}
						handleCloseClick={this.onCancelButton}
					/>
					{/*<Slide right cascade opposite when={this.state.trigger}>*/}
						<MDBBox className={'elipse-section'}>
							<img src={Phone} alt={"altImage"} className={"phone-img"}/>
							<img src={Lock} alt={"altImage"} className={"lock-img animate__animated animate__zoomIn"}/>
							<img src={RedDots} alt={"altImage"} className={"red-dot-icon animate__animated animate__zoomIn"}/>
							<img src={NetaLogo} alt={"altImage"} className={"neta-logo animate__animated animate__zoomIn"}/>

						</MDBBox>

						<MDBBox className="create-password-form-section ">
							<MDBTypography tag="h4" className="title my-2">{this.props.forgetPinIs?"Update Your PIN":"Enter a 4 Digit Pin"}</MDBTypography>
							<MDBTypography tag="p" className="description mt-3 mb-3">{this.props.forgetPinIs?"Your PIN will be updated":"This pin will be used when you buy/sell shares"}</MDBTypography>
							<form>
								{/*<input type="email"*/}
								{/*       className="form-control form-control-md"*/}
								{/*       placeholder="Email Id"*/}
								{/*       value={this.state.email}*/}
								{/*       onChange={(e)=>this.handleInputChange(e,"email")}*/}
								{/*/>*/}
								{/*<br />*/}
								<div  className={"position-relative"}>
									{
										this.state.show_password1 === true &&
										<input type={"number"}
											   pattern="[0-9]*"
											   maxLength="4"
											   inputMode={"numeric"}
											   className="form-control mt-3 form-control-md"
											   placeholder="Your PIN"
											   value={this.state.pin}
											   onChange={(e) => this.handleInputChange(e, "pin")}
											   onInput={(e) => this.handleInputChange(e, "pin")}
											   onKeyDown={(e) => {
												   if (e.key === 'Enter') {
													   this.handleSubmit(e);
												   }
											   }}

										/>
									}
									{
										this.state.show_password1 === false &&
										<input type={"password"}
											   pattern="[0-9]*"
											   maxLength="4"
											   inputMode={"numeric"}
											   className="form-control mt-3 form-control-md"
											   placeholder="Your PIN"
											   value={this.state.pin}
											   onChange={(e) => this.handleInputChange(e, "pin")}
											   onInput={(e) => this.handleInputChange(e, "pin")}
											   onKeyDown={(e) => {
												   if (e.key === 'Enter') {
													   this.handleSubmit(e);
												   }
											   }}

										/>
											}

									<img alt={"alt"} src={this.state.show_password1 === true?eye:eyelash} className={"eye-icon"} onClick={this.togglePassword} />
								</div>

								{/*<br/>*/}
								<div className={"position-relative"}>
									{
										this.state.show_password2 === true &&
										<input type={"number"}
											   pattern="[0-9]*"
											   maxLength="4"
											   inputMode={"numeric"}
											   className="form-control mt-3 form-control-md"
											   placeholder="Confirm PIN"
											   value={this.state.confirm_pin}
											   onKeyDown={(e) => {
												   if (e.key === 'Enter') {
													   this.handleSubmit(e);
												   }
											   }}
											   onChange={(e) => this.handleInputChange(e, "confirm_pin")}
											   onInput={(e) => this.handleInputChange(e, "confirm_pin")}
										/>
									}
									{
										this.state.show_password2 === false &&
										<input type={"password"}
											   pattern="[0-9]*"
											   maxLength="4"
											   inputMode={"numeric"}
											   className="form-control mt-3 form-control-md"
											   placeholder="Confirm PIN"
											   value={this.state.confirm_pin}
											   onKeyDown={(e) => {
												   if (e.key === 'Enter') {
													   this.handleSubmit(e);
												   }
											   }}
											   onChange={(e) => this.handleInputChange(e, "confirm_pin")}
											   onInput={(e) => this.handleInputChange(e, "confirm_pin")}
										/>
									}

									<img alt={"alt"} src={this.state.show_password2 === true?eye:eyelash} className={"eye-icon"} onClick={this.togglePasswordConfirm} />
								</div>

							</form>
						</MDBBox>
					{/*</Slide>*/}
				</MDBBox>
				<button className="btn submit-btn text-white"
				        onClick={(e) => this.handleSubmit(e)}
				        id={"submitButton-new"}
				        disabled={this.state.loading}
				>
					Set Pin
					<MDBIcon icon="angle-right" className="mx-2"/>
				</button>
			</MDBBox>
		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
})
const mapDispatchToProps = dispatch => ({
	addUserData: data => dispatch(userLogin(data)),
	setLoginStep: data => dispatch(setLoginStep(data)),
	setForgetPin: data => dispatch(setForgetPin(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreateNewPin));
